export default __webpack_public_path__ + "img/bffwdEkt.98fe3503.svg";